// returns value between 255 (brightest) and 0 (darkest)
async function getImageBrightness(imageData) {
  return new Promise((resolve) => {
    const blob = new Blob([imageData]);
    const imgUrl = URL.createObjectURL(blob);

    const img = document.createElement("img");
    img.src = imgUrl;
    img.style.display = "none";
    window.document.body.appendChild(img);

    let colorSum = 0;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      let r, g, b, avg;

      for (let x = 0, len = data.length; x < len; x += 4) {
        r = data[x];
        g = data[x + 1];
        b = data[x + 2];

        avg = Math.floor((r + g + b) / 3);
        colorSum += avg;
      }

      const brightness = Math.floor(colorSum / (img.width * img.height));
      resolve(brightness);
      if (img) img.remove();
      if (canvas) canvas.remove();
      URL.revokeObjectURL(imgUrl);
    };
  });
}

async function isImageDark(imageData) {
  const imageBrightness = await getImageBrightness(imageData);
  return imageBrightness < 10;
}

export { getImageBrightness, isImageDark };
